import { init as _initMito } from '@mitojs/browser';
import { ErrorTypes, networkErrorMessages } from './config.mjs';
import { Env } from '@voghion/fe-util';
import { addStringValueToParams } from "../ga/util.mjs";
import { EVENT_EXCEPTION } from "../utils/config.mjs";
import { getNetworkInfo } from "../utils/network.mjs";
/**
 * 上报异常
 * @param params
 * @returns
 */
export const trackException = (params) => {
    params.network_info = getNetworkInfo();
    if (params.description && networkErrorMessages.includes(params.message)) {
        params.network_error = true;
    }
    if (!('fatal' in params)) {
        params.fatal = false;
    }
    if (monitorOptions &&
        monitorOptions.exceptionFilter &&
        monitorOptions.exceptionFilter(params)) {
        return;
    }
    const env = Env.getInstance();
    if (!env.isClient) {
        return console.error(`[${params.error_type}] ${JSON.stringify(Object.assign(Object.assign({}, params), { error_type: undefined, fatal: undefined }))}`);
    }
    if (monitorOptions && monitorOptions.trackEvent) {
        monitorOptions.trackEvent(EVENT_EXCEPTION, params);
    }
};
/**
 * 上报 API 异常
 * @param params
 */
export const trackApiException = (params) => {
    params.error_type = ErrorTypes.Api;
    trackException(params);
};
/**
 * 上报 axios 异常
 * @param response
 */
export const trackAxiosException = (response) => {
    const { request } = response;
    let requestUrl = request === null || request === void 0 ? void 0 : request.responseURL;
    let requestMethod = 'POST';
    let requestData = '';
    if (request && request.httpCollect) {
        const { httpCollect } = request;
        // @mitojs/browser 会重写 xhr 的 open 并添加 httpCollect 对象
        requestUrl = httpCollect.request.url;
        requestMethod = httpCollect.request.method;
        requestData = httpCollect.request.data || '';
    }
    if (response.config) {
        const { config } = response;
        if (config.method) {
            requestMethod = config.method.toUpperCase();
        }
        requestData = config.data || '';
    }
    if (typeof requestData === 'object') {
        requestData = JSON.stringify(requestData);
    }
    const params = {
        request_url: requestUrl,
        request_method: requestMethod,
        response_status: response.status || 500,
        request_data: '',
        description: ''
    };
    let responseData = '';
    let description = '';
    if ('stack' in response && response.stack) {
        // 如果是 AxiosError
        addStringValueToParams(params, 'stack', response.stack);
        description = response.message;
    }
    else if ('data' in response) {
        // 如果是接口业务错误
        const { data } = response;
        responseData = typeof data === 'object' ? JSON.stringify(data) : data;
        description = typeof data === 'object' ? data.rtn_msg || '' : data;
    }
    params.description = description;
    addStringValueToParams(params, 'request_data', requestData);
    addStringValueToParams(params, 'response_data', responseData);
    trackApiException(params);
};
/**
 * 上报 API 异常
 * @param params
 */
export const trackVendorApiException = (params) => {
    params.error_type = ErrorTypes.VendorApi;
    trackException(params);
};
let monitorClient = null;
let monitorOptions = null;
/**
 * 是否是自有 api
 * @param request_url
 */
const checkSelfApi = (requestURL) => {
    const pageSymbol = location.hostname.split('.').slice(-2, -1);
    const urlInfo = new URL(requestURL);
    const apiSymbol = urlInfo.hostname.split('.').slice(-2, -1);
    return pageSymbol === apiSymbol;
};
/**
 * 初始化监控
 * @param options
 */
export const initMonitor = (options) => {
    if (monitorClient) {
        return monitorClient;
    }
    if (!('autoTrackSelfApi' in options)) {
        options.autoTrackSelfApi = true;
    }
    monitorOptions = options;
    monitorClient = _initMito(Object.assign(Object.assign({ debug: false, dsn: '', 
        // 堆栈太大会超过 ga 64kb 的限制
        maxBreadcrumbs: 5 }, options), { beforeDataReport(event) {
            var _a;
            if (event && event.data) {
                const { data } = event;
                if (data.type === 'HTTP') {
                    const { request, response } = data;
                    /**
                     * 如果有响应但状态为 0 的请求大概率都是 cors 错误
                     * cors 错误不记录，大部分埋点都是跨域请求
                     */
                    const corsError = 'data' in response && response.status === 0;
                    if (request && response && !corsError) {
                        const params = {
                            request_url: request.url,
                            request_data: '',
                            request_method: ((_a = request.method) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || 'POST',
                            response_data: '',
                            response_status: response.status,
                            description: data.message || ''
                        };
                        addStringValueToParams(params, 'request_data', request.data || '');
                        addStringValueToParams(params, 'response_data', response.data || '');
                        if (checkSelfApi(params.request_url)) {
                            if (options.autoTrackSelfApi) {
                                trackApiException(params);
                            }
                        }
                        else if (!params.request_url.includes('googleapis.com') &&
                            !params.request_url.includes('analytics.google.com')) {
                            // firebase 安装错误和 ga 自身的错误不上报，大概率都是网络引起的超时或者重定向
                            trackVendorApiException(params);
                        }
                    }
                }
                else if (data.type === 'RESOURCE') {
                    if (data.message) {
                        const resourceUrl = data.message.replace('资源地址: ', '');
                        // 第三方域名的图片加载错误不上报，大概率都是埋点触发的
                        if (checkSelfApi(resourceUrl)) {
                            trackException({
                                error_type: data.type,
                                description: resourceUrl
                            });
                        }
                    }
                }
                else if (data.type) {
                    const params = {
                        error_type: data.type,
                        description: data.message || ''
                    };
                    if (data.stack) {
                        addStringValueToParams(params, 'stack', typeof data.stack === 'object'
                            ? JSON.stringify(data.stack)
                            : data.stack);
                    }
                    trackException(params);
                }
            }
            return false;
        } }));
    return monitorClient;
};
